import { getAccountList } from '@repo/accounts-services'
import { defineSagaForService } from '@repo/core'
import { accountListDataActions } from '../../../slices'

export const serviceConfig = defineSagaForService({
  [accountListDataActions.getRequest.type]: {
    apiClientDomain: 'accounts',
    service: getAccountList,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: accountListDataActions.getResponse.type,
    actionTypeRequest: accountListDataActions.getRequest.type,
  },
  [accountListDataActions.refreshRequest.type]: {
    apiClientDomain: 'accounts',
    service: getAccountList,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: accountListDataActions.refreshResponse.type,
    actionTypeRequest: accountListDataActions.refreshRequest.type,
  },
})
